const offeringTypes = {
  GET_OFFERTS_REQUEST: "GET_OFFERTS_REQUEST",
  GET_OFFERTS_SUCCESS: "GET_OFFERTS_SUCCESS",
  GET_OFFERTS_FAILED: "GET_OFFERTS_FAILED",
  GET_MY_OFFERTS_REQUEST: "GET_MY_OFFERTS_REQUEST",
  GET_MY_OFFERTS_SUCCESS: "GET_MY_OFFERTS_SUCCESS",
  GET_MY_OFFERTS_FAILED: "GET_MY_OFFERTS_FAILED",
  POST_OFFERT_REQUEST: "POST_OFFERT_REQUEST",
  POST_OFFERT_SUCCESS: "POST_OFFERT_SUCCESS",
  POST_OFFERT_FAILED: "POST_OFFERT_FAILED",
  PUT_OFFERT_REQUEST: "PUT_OFFERT_REQUEST",
  PUT_OFFERT_SUCCESS: "PUT_OFFERT_SUCCESS",
  PUT_OFFERT_FAILED: "PUT_OFFERT_FAILED",
  DELETE_OFFERT_REQUEST: "DELETE_OFFERT_REQUEST",
  DELETE_OFFERT_SUCCESS: "DELETE_OFFERT_SUCCESS",
  DELETE_OFFERT_FAILED: "DELETE_OFFERT_FAILED",
  HANDLE_OFFERT_REQUEST: "HANDLE_OFFERT_REQUEST",
  HANDLE_OFFERT_SUCCESS: "HANDLE_OFFERT_SUCCESS",
  HANDLE_OFFERT_FAILED: "HANDLE_OFFERT_FAILED",
  RESET_MY_OFFERTS: "RESET_MY_OFFERTS",
  RESET_OFFERTS: "RESET_OFFERTS",
}

export { offeringTypes };